import Reveal from '../components/Reveal';
import { CLIENTS } from '../data';

import rdLogo   from '../assets/client_royaldivine.jpeg';
import rpLogo   from '../assets/client_redplanet.jpeg';
import siLogo   from '../assets/client_soldinsight.webp';
import srdLogo  from '../assets/client_srd.png';
const CLIENT_LOGOS = { 'client_royaldivine.jpeg': rdLogo, 'client_redplanet.jpeg': rpLogo, 'client_soldinsight.webp': siLogo, 'client_srd.png': srdLogo };

export default function About({ openForm }) {
  return (
    <div style={{ paddingTop: 90 }}>
      <section className="section">
        <div className="container">
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 72, alignItems: 'center', marginBottom: 72 }}>
            <Reveal>
              <span className="tag">Our Story</span>
              <h1 style={{ fontFamily: 'var(--fD)', fontSize: 'clamp(28px,4vw,50px)', fontWeight: 900, lineHeight: 1.05, marginBottom: 20 }}>
                Built for real estate.<br />Obsessed with results.
              </h1>
              <p style={{ color: 'var(--mut)', fontSize: 16, lineHeight: 1.85, marginBottom: 16 }}>
                Neural Media Solutions was founded with a singular vision: to empower real estate businesses in India with cutting-edge digital marketing that delivers tangible, high-quality results.
              </p>
              <p style={{ color: 'var(--mut)', fontSize: 16, lineHeight: 1.85, marginBottom: 40 }}>
                With deep understanding of the Indian property market and over ₹40 Lakhs in managed ad spend, we've built a reputation for driving real growth — not just impressions.
              </p>
              <div style={{ display: 'flex', gap: 36, flexWrap: 'wrap' }}>
                {[['₹40L+','Managed'], ['20+','Clients'], ['4+','Services'], ['2+','Years']].map(([v, l]) => (
                  <div key={l}>
                    <div style={{ fontFamily: 'var(--fD)', fontSize: 32, fontWeight: 900, color: 'var(--acc)', lineHeight: 1 }}>{v}</div>
                    <div style={{ color: 'var(--mut)', fontSize: 12, marginTop: 4 }}>{l}</div>
                  </div>
                ))}
              </div>
            </Reveal>

            <Reveal delay={0.15}>
              <div style={{ background: 'var(--surf)', border: '1px solid var(--bdr)', borderRadius: 20, padding: 40 }}>
                <h3 style={{ fontFamily: 'var(--fD)', fontWeight: 900, fontSize: 22, marginBottom: 24 }}>What Makes Us Unique</h3>
                {[
                  { icon: '🏠', title: 'Real Estate Specialization', desc: 'Deep expertise in property sales cycles, buyer psychology, and inquiry qualification for Indian markets.' },
                  { icon: '📈', title: 'Performance-Driven Only',    desc: 'Every campaign is optimized for ROI and inquiry quality — not just impressions or vanity metrics.' },
                  { icon: '🤖', title: 'AI-Powered Campaigns',       desc: 'Leveraging the latest AI tools and ad platform algorithms to keep your campaigns ahead of competition.' },
                  { icon: '🤝', title: 'Developers & Partners',      desc: 'Specialized strategies for both large developers launching projects and channel partners building their brand.' },
                ].map((w, i) => (
                  <div key={i} style={{ display: 'flex', gap: 14, marginBottom: 22 }}>
                    <div style={{ fontSize: 24, lineHeight: 1, flexShrink: 0 }}>{w.icon}</div>
                    <div>
                      <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 4 }}>{w.title}</div>
                      <div style={{ color: 'var(--mut)', fontSize: 14, lineHeight: 1.65 }}>{w.desc}</div>
                    </div>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>

          {/* Clients */}
          <Reveal>
            <h2 style={{ fontFamily: 'var(--fD)', fontWeight: 900, fontSize: 'clamp(22px,3.5vw,38px)', marginBottom: 32 }}>
              Trusted by industry leaders.
            </h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px,1fr))', gap: 16, marginBottom: 64 }}>
              {CLIENTS.map((c, i) => (
                <div key={i} style={{ background: 'var(--surf)', border: '1px solid var(--bdr)', borderRadius: 16, padding: 24, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 14 }}>
                  <div style={{ width: 72, height: 72, borderRadius: 12, overflow: 'hidden', background: '#000', border: '1px solid rgba(255,255,255,0.1)' }}>
                    <img src={CLIENT_LOGOS[c.logo]} alt={c.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  </div>
                  <div style={{ fontWeight: 600, fontSize: 14, textAlign: 'center' }}>{c.name}</div>
                </div>
              ))}
            </div>
          </Reveal>

          <div style={{ textAlign: 'center' }}>
            <Reveal>
              <h2 style={{ fontFamily: 'var(--fD)', fontWeight: 900, fontSize: 'clamp(26px,4vw,46px)', marginBottom: 16 }}>Want to be our next success story?</h2>
              <button onClick={openForm} className="btn btn-teal" style={{ fontSize: 16, padding: '16px 32px' }}>Work With Us →</button>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
